<div class="pt-8 pb-16 px-2 md:py-[30px] md:px-[20px] md:px-[50px]">
  <div *ngIf="!showSteps; else steps">
    <div>
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-booking-color-bg.svg" alt="" />
      <img class="mx-2" src="/assets/v4/icon-link-arrow.svg" alt="" />
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-hostex-color.svg" alt="" />
    </div>

    <div class="text-l font-bold text-center mt-[30px] md:text-left">
      {{ "channel-connect_booking_html_标题" | translate }}
      <!-- Connect with Booking.com -->
    </div>

    <div class="text-m mt-[30px]">
      {{ "channel-connect_booking_html_描述" | translate }}
      <!-- Hostex is an official Booking.com connectivity partner, so we can connect with your account reliably and securely. -->
    </div>

    <div class="text-m mt-[30px]">
      <div>
        {{ "channel-connect_booking_html_注意事项" | translate }}
        <!-- Before you start connecting, you need to know the following things. -->
      </div>
      <ol>
        <li [innerHTML]="'channel-connect_booking_html_注意事项1' | translate">
          <!-- 1. Due to Booking.com's API restrictions,
          <span class="font-bold">reservations made before the connection cannot be synchronized to Hostex,</span> and
          the relevant automation rules cannot work. -->
        </li>
        <li [innerHTML]="'channel-connect_booking_html_注意事项2' | translate">
          <!-- 2. <span class="font-bold">Remember to set the price</span> for your Booking.com listing in good time after
          you connect, as <span class="font-bold">Booking.com will erase any previous price settings.</span> -->
        </li>
      </ol>
    </div>

    <div class="fixed bottom-[20px] left-[20px] right-[20px] md:relative md:mt-12 md:text-right">
      <button class="w-full mb-3 md:mb-0 md:mr-3 md:w-auto" nz-button nzSize="large" (click)="onCancel()">
        {{ "word.cancel" | translate }}
        <!-- Cancel -->
      </button>
      <button class="w-full md:w-auto" nz-button nzType="primary" nzSize="large" (click)="onAuth()">
        {{ "channel-connect_booking_html_我明白了" | translate }}
        <!-- I understand and want to connect -->
      </button>
    </div>
  </div>
</div>

<ng-template #steps>
  <!-- step1 -->
  <div class="v4-layout-form text-center md:text-left" *ngIf="step === 1">
    <div class="v4-layout-form-title">
      {{ "channel-connect_booking_html_booking登录" | translate }}
      <!-- Enter your Booking.com login -->
    </div>
    <div class="v4-layout-form-desc">
      {{ "channel-connect_booking_html_booking输入邮箱" | translate }}
      <!-- Enter the email or username you use to log in to your Booking.com account. -->
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <input
          type="text"
          nz-input
          nzSize="large"
          [placeholder]="'channel-connect_booking_html_booking登录' | translate"
          [(ngModel)]="username" />
      </div>
    </div>

    <div class="footer text-right mt-[30px]">
      <button class="mr-3" nz-button nzSize="large" (click)="showSteps = false">
        {{ "word.return" | translate }}
        <!-- Back -->
      </button>
      <button nz-button nzSize="large" nzType="primary" [disabled]="!username" (click)="onNext()">
        {{ "word.next" | translate }}
        <!-- Next -->
      </button>
    </div>
  </div>

  <!-- step2 -->
  <div class="v4-layout-form" *ngIf="step === 2">
    <div class="v4-layout-form-title">
      {{ "channel-connect_booking_html_找到id" | translate }}
      <!-- Find your Hotel ID -->
    </div>
    <div class="v4-layout-form-desc">
      <a href="https://admin.booking.com/hotel/hoteladmin/groups/home/" target="_blank" class="font-bold">
        {{ "channel-connect_booking_html_点击登录" | translate }}
        <!-- Click to log in -->
      </a>
      {{ "channel-connect_booking_html_booking账号" | translate }}
      <!-- to your
      Booking.com account, then find the hotel IDs as shown. -->
    </div>

    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <img class="w-full" src="https://oss.image.xiaogetech.com/KPQ1679542107848.png" alt="" />
      </div>
    </div>

    <div class="footer text-right mt-[30px]">
      <button class="mr-3" nz-button nzSize="large" (click)="step = 1">
        {{ "word.return" | translate }}
        <!-- Back -->
      </button>
      <button nz-button nzSize="large" nzType="primary" (click)="onNext()">
        {{ "channel-connect_booking_html_我找到了" | translate }}
        <!-- I found it -->
      </button>
    </div>
  </div>

  <!-- step3 -->
  <div class="v4-layout-form" *ngIf="step === 3">
    <div class="v4-layout-form-title">
      {{ "channel-connect_booking_html_输入ids" | translate }}
      <!-- Input the hotel IDs you want to connect -->
    </div>
    <div class="v4-layout-form-desc">
      {{ "channel-connect_booking_html_复制ids" | translate }}
      <!-- Copy & paste all your hotel IDs you want to connect, one per line. Click on "Add" to add new lines. -->
    </div>
    <div class="v4-layout-field" *ngFor="let hotel of hotelIds; first as isFirst; index as i">
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row relative">
          <input
            type="text"
            nz-input
            nzSize="large"
            [placeholder]="'channel-connect_with_booking_html_placeholder_id' | translate"
            [(ngModel)]="hotel.value" />
          <i
            *ngIf="!isFirst"
            class="cursor-pointer absolute -right-5 top-1/2 -translate-y-1/2"
            nz-icon
            nzType="minus-circle"
            nzTheme="fill"
            (click)="onRemoveHotelId(i)"></i>
        </div>
      </div>
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <button nz-button (click)="onAddHotelId()">
          {{ "channel-connect_booking_html_添加" | translate }}
          <!-- + Add -->
        </button>
      </div>
    </div>

    <div class="footer text-right mt-[30px]">
      <button class="mr-3" nz-button nzSize="large" (click)="step = 2">
        {{ "word.return" | translate }}
        <!-- Back -->
      </button>
      <button nz-button nzSize="large" nzType="primary" (click)="onNext()">
        {{ "word.next" | translate }}
        <!-- Next -->
      </button>
    </div>
  </div>

  <!-- step4 -->
  <div class="v4-layout-form" *ngIf="step === 4">
    <div class="v4-layout-form-title">
      {{ "channel-connect_booking_html_设置hostex" | translate }}
      <!-- Set Hostex as your connectivity provider -->
    </div>
    <div class="v4-layout-form-desc">
      <a
        class="font-bold"
        href="https://admin.booking.com/hotel/hoteladmin/groups/bulk_switch_provider/index.html"
        target="_blank">
        {{ "channel-connect_booking_html_点击登录" | translate }}
        <!-- Click to log in -->
      </a>
      {{ "channel-connect_booking_html_跟随步骤" | translate }}
      <!-- to your
      Booking.com account to your Booking.com account, and follow the slide show step by step to set up Hostex as your
      connectivity provider. -->
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control relative" style="width: 100%; height: 362px">
        <img
          (click)="carousel.pre()"
          class="absolute cursor-pointer top-1/2 left-0 z-10"
          src="/assets/v4/icon-arrow-prev.svg"
          alt="" />
        <img
          (click)="carousel.next()"
          class="absolute cursor-pointer top-1/2 right-0 z-10"
          src="/assets/v4/icon-arrow-next.svg"
          alt="" />
        <nz-carousel #carousel>
          <div *ngFor="let i of carouselImgs" nz-carousel-content style="height: 360px">
            <img class="h-full mx-auto" [src]="i" alt="" />
          </div>
          <!-- <div class="w-full h-44" nz-carousel-content style="height: 140px; background-color: red">
            <img src="https://techer-demo.oss-cn-beijing.aliyuncs.com/ob/alipay.png" alt="" />
          </div>
          <div class="w-full h-44" nz-carousel-content style="height: 140px; background-color: red">
            <img src="https://techer-demo.oss-cn-beijing.aliyuncs.com/ob/alipay.png" alt="" />
          </div> -->
        </nz-carousel>
      </div>
    </div>
    <div class="footer text-right mt-[30px]">
      <button class="mr-3" nz-button nzSize="large" (click)="step = 3">
        {{ "word.return" | translate }}
        <!-- Back -->
      </button>
      <button nz-button nzSize="large" nzType="primary" (click)="onComplete()" [nzLoading]="loading">
        {{ "channel-connect_booking_html_完成" | translate }}
        <!-- I have finished -->
      </button>
    </div>
  </div>

  <!-- step5 -->
  <div class="v4-layout-form" *ngIf="step === 5">
    <div class="v4-layout-form-title">
      {{ "channel-connect_booking_html_检查连接" | translate }}
      <!-- Check your connection -->
    </div>
    <div class="v4-layout-form-desc">
      {{ "channel-connect_booking_html_检查连接说明" | translate }}
      <!-- After you set Hostex as the connectivity provider, click “Check”. -->
    </div>
    <div class="footer text-right mt-[30px]">
      <button class="mr-3" nz-button nzSize="large" (click)="step = 3">
        {{ "word.return" | translate }}
        <!-- Back -->
      </button>
      <button nz-button nzSize="large" nzType="primary" (click)="onComplete()" [nzLoading]="loading">
        {{ "channel-connect_booking_html_检查" | translate }}
        <!-- Check -->
        <!-- I have finished -->
      </button>
    </div>
  </div>

  <!-- @if (step === 6) {
    <host-set-pricing-ratio (onBack)="step = 5" (onNext)="onFinish()"></host-set-pricing-ratio>
  } -->
</ng-template>
